import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { textLegacyDefaultDataSchema } from './data';

/**
 * Default-placement legacy text envelope.
 *
 * `type` is `z.literal('default').optional()` so that persisted entities
 * written before the discriminator existed (which omit `type` entirely) still
 * parse here, and the zod discriminated union in `./entity.ts` can dispatch on
 * `type`. Mirrors the button/form envelope pattern.
 */
export const textLegacyDefaultV0Schema = z.object({
    id: z.string(),
    name: z.literal('text'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('default').optional(),
    data: textLegacyDefaultDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
